import { render } from "./orthopedic_procedures.vue?vue&type=template&id=61fb2588&scoped=true"
import script from "./orthopedic_procedures.vue?vue&type=script&lang=js"
export * from "./orthopedic_procedures.vue?vue&type=script&lang=js"

import "./orthopedic_procedures.vue?vue&type=style&index=0&id=61fb2588&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61fb2588"]])

export default __exports__